var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreMarker2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 59,
    viewBox: "0 0 47 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_246_1330)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_246_1330",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 59
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.7926 0H0V59H46.7926V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_246_1330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7955 23.3977C46.7955 32.1957 41.9328 39.8553 34.7499 43.8426L24.7817 58.269C24.6279 58.4943 24.4215 58.6786 24.1803 58.8059C23.9391 58.9333 23.6705 58.9999 23.3977 58.9999C23.125 58.9999 22.8564 58.9333 22.6152 58.8059C22.374 58.6786 22.1676 58.4943 22.0138 58.269L12.0456 43.8426C4.86273 39.8553 0 32.1957 0 23.3977C0 10.4767 10.4796 0 23.3977 0C36.3159 0 46.7955 10.4767 46.7955 23.3977Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3981 38.5897C31.7885 38.5897 38.5902 31.788 38.5902 23.3976C38.5902 15.0073 31.7885 8.20557 23.3981 8.20557C15.0078 8.20557 8.20605 15.0073 8.20605 23.3976C8.20605 31.788 15.0078 38.5897 23.3981 38.5897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8805 16.1284L22.4916 13.2289C21.9193 12.9237 21.2421 12.9237 20.6698 13.2289L15.2904 16.1284C14.8994 16.3478 14.6514 16.7675 14.6514 17.2253C14.6514 17.6926 14.8898 18.1123 15.2904 18.3222L20.6793 21.2216C20.9655 21.3742 21.2803 21.4506 21.5855 21.4506C21.8907 21.4506 22.215 21.3742 22.4916 21.2216L27.8805 18.3222C28.2715 18.1123 28.5195 17.6926 28.5195 17.2253C28.5195 16.7675 28.2715 16.3478 27.8805 16.1284Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.791 22.2324L14.7836 19.7335C14.3926 19.5332 13.9538 19.5618 13.5818 19.7811C13.2194 20.0101 13 20.4011 13 20.8303V25.5612C13 26.3814 13.4578 27.1158 14.1923 27.4878L19.1996 29.9868C19.3713 30.0726 19.5621 30.1203 19.7529 30.1203C19.9722 30.1203 20.2011 30.0535 20.4014 29.939C20.7639 29.7101 20.9832 29.319 20.9832 28.8899V24.1591C20.9737 23.3388 20.5159 22.6044 19.791 22.2324Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.169 20.8303V23.1767C29.7112 23.0431 29.2247 22.9859 28.7383 22.9859C27.4412 22.9859 26.1726 23.4342 25.1712 24.2353C23.7977 25.3132 23.0156 26.9441 23.0156 28.7086C23.0156 29.176 23.0728 29.6433 23.1968 30.0916C23.0537 30.0726 22.9107 30.0153 22.7771 29.9295C22.4147 29.7101 22.1953 29.319 22.1953 28.8899V24.1591C22.1953 23.3388 22.6531 22.6044 23.378 22.2324L28.3854 19.7335C28.7765 19.5332 29.2152 19.5618 29.5872 19.7811C29.9496 20.0101 30.169 20.4011 30.169 20.8303Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0575 25.9898C31.2754 25.0265 30.0831 24.416 28.7383 24.416C27.7273 24.416 26.7926 24.769 26.0581 25.3603C25.0662 26.1424 24.4463 27.3537 24.4463 28.7081C24.4463 30.0529 25.0567 31.2452 26.02 32.0273C26.7544 32.6377 27.7082 33.0001 28.7383 33.0001C29.8256 33.0001 30.808 32.59 31.5711 31.9319C32.4581 31.1402 33.0303 29.9957 33.0303 28.7081C33.0303 27.678 32.6679 26.7242 32.0575 25.9898ZM29.7207 28.9751C29.7207 29.2231 29.5872 29.4616 29.3773 29.5856L28.0325 30.3868C27.9181 30.4535 27.7941 30.4917 27.6605 30.4917C27.4221 30.4917 27.1837 30.3677 27.0501 30.1483C26.8498 29.8049 26.9547 29.3662 27.2981 29.1659L28.2901 28.5745V27.3728C28.2901 26.9818 28.6143 26.6575 29.0054 26.6575C29.3965 26.6575 29.7207 26.9818 29.7207 27.3728V28.9751Z",
    fill: "#FF0000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_246_1330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 59,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreMarker2);
export default __webpack_public_path__ + "static/media/storeMarker 2.7cf08ab637afb25d962a4b5b3a707357.svg";
export { ForwardRef as ReactComponent };